import { addMessages, init, getLocaleFromPathname, locale } from 'svelte-i18n';
import { derived } from 'svelte/store';

import en from './locales/en.json';
import de from './locales/de.json';

addMessages('en', en);
addMessages('de', de);

init({
  fallbackLocale: 'en',
  initialLocale: 'en',
});

const siteIds = {
  "en": "1",
  "de": "2"
}

export const siteId = derived(
  locale,
  locale => (siteIds[locale] || "1")
);